module.exports = __webpack_public_path__ + "static/media/σώμα μας.572f1887.vtt";